import styled from 'styled-components/macro';
import { DarkBlueHeaderXS } from '../../../Themes';

export const DropdownMenuHd = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 0 18px 0 18px;
`;

export const DropdownHd = styled(DarkBlueHeaderXS)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: #21679a;
  font-size: 1.3rem;
  min-width: 0;
  flex: 1;
`;

export const DropdownArr = styled.img`
  margin-left: auto;
`;

export const DropdownOptionsWrapper = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 30;
  min-width: 100%;
  width: max-content;
  max-width: min(42rem, 90vw);
  max-height: 28rem;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.backgrounds.white};
  box-shadow: ${({ theme }) => theme.shadows.lighter};
  border-radius: ${({ theme }) => theme.borderRadius.md * 0.9}px;
  user-select: none;

  &::-webkit-scrollbar {
    width: 0;
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
  }
`;

export const DropdownOption = styled(DarkBlueHeaderXS)`
  padding: 0 0 0 28px;
  line-height: 3rem;
  user-select: none;
  white-space: nowrap;
  display: flex;
  align-items: center;
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  opacity: 48%;
  font-size: 1.1rem;

  &:hover {
    opacity: 100%;
  }
`;

export const DropdownParentOption = styled(DarkBlueHeaderXS)`
  padding: 0 0 0 18px;
  user-select: none;
  white-space: nowrap;
  display: flex;
  align-items: center;
  opacity: 48%;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  font-size: 1.3rem;

  &:hover {
    opacity: 100%;
  }
`;

export const DropdownContainer = styled.div<{ $disabled?: boolean; $open?: boolean }>`
  background-color: ${({ theme }) => theme.backgrounds.white};
  box-shadow: ${({ theme }) => theme.shadows.lighter};
  border-radius: ${({ theme }) => theme.borderRadius.md * 0.9}px;
  margin-right: ${({ theme }) => theme.padding}px;
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  flex: 1;
  user-select: none;
  height: 40px;
  min-width: 0;
  max-width: calc(33.33% - ${({ theme }) => theme.padding}px);
  opacity: ${({ $disabled }) => ($disabled ? 0.55 : 1)};
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
  overflow: visible;
  z-index: ${({ $open }) => ($open ? 20 : 1)};
`;
